import { ModuleWithProviders, NgModule } from '@angular/core';
import { BPM_RUNTIME_DEVKIT_PROVIDERS } from '../providers';
import { BpmRuntimeDevkitModule } from '../bpm-runtime-devkit/bpm-runtime-devkit.module';

@NgModule({
    imports: [
        BpmRuntimeDevkitModule,
    ],
    providers: [
        ...BPM_RUNTIME_DEVKIT_PROVIDERS,
    ],
})
export class BpmRuntimeDevkitWebCmpModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: BpmRuntimeDevkitWebCmpModule,
            providers: [
            ]
        }
    }
}
